// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"47488cd2","85":"06dd9b90","239":"271ef706","394":"86e75dce","432":"4a04db5e","444":"75fbad72","457":"67256bf7","478":"be6f7cb4","529":"5082a4a1","556":"6cea91bb","711":"99974d9d","734":"4b032037","783":"705c707f","802":"f68f4fa7","896":"2108933a","931":"89585291"}[chunkId] + ".chunk.js";
};